import { useEffect, useState } from 'react';

// Dónde viven los videos, el catálogo y las novedades. En producción es la URL de CloudFront
// (`VITE_TUTORIALES_BASE_URL`, que ya incluye /v1); sin ella se leen de `public/tutoriales/` (desarrollo y pruebas).
export const BASE_CONTENIDO = import.meta.env?.VITE_TUTORIALES_BASE_URL || '/tutoriales';

/**
 * Descarga un JSON del contenido de ayuda. `null` mientras no se pide o si falla (la ayuda nunca debe romper la app).
 * Cada archivo se pide una sola vez por carga de página.
 */
const memoria = new Map();
export function limpiarMemoriaContenido() {
  memoria.clear();
}

export function useJsonAyuda(archivo, { activo = true, base = BASE_CONTENIDO } = {}) {
  const url = `${String(base).replace(/\/+$/, '')}/${archivo}`;
  const [datos, setDatos] = useState(() => memoria.get(url) ?? null);

  useEffect(() => {
    if (!activo || memoria.has(url)) {
      if (memoria.has(url)) setDatos(memoria.get(url));
      return undefined;
    }
    let cancelado = false;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((json) => {
        if (json != null) memoria.set(url, json);
        if (!cancelado) setDatos(json);
      });
    return () => {
      cancelado = true;
    };
  }, [url, activo]);

  return datos;
}
